// extracted by mini-css-extract-plugin
export default {"App":"App_App__kayfH","App-logo":"App_App-logo__jzNql","App-logo-spin":"App_App-logo-spin__eRUg0","App-header":"App_App-header__htIDI","App-link":"App_App-link__VVBj3"};